document.addEventListener('DOMContentLoaded', function() {
    var REDIRECT_PATH = '/account';
  
    var selector = '#create_customer',
        $signForm = document.querySelectorAll(selector)[0];
  
    if ($signForm) {
      $redirect = document.createElement('input');
      $redirect.setAttribute('name', 'return_to');
      $redirect.setAttribute('type', 'hidden');
      $redirect.value = REDIRECT_PATH;
      $signForm.appendChild($redirect);
    }
  },false);